import { ProductColor } from '@ravago/shared/page-data/models/elements';

import { OTHER_COLOR_ID, UNKNOWN_COLOR_ID } from '../constants';

const OTHER_COLOR_NAME = 'Other';
const UNKNOWN_COLOR_NAME = 'Unknown';

export const getColorNameFromId = (colors: ProductColor[], id: number) => {
   if (id === OTHER_COLOR_ID) return OTHER_COLOR_NAME;
   if (id === UNKNOWN_COLOR_ID) return UNKNOWN_COLOR_NAME;
   return colors.find((color) => color.id === id)?.name;
};

export const getColorIdFromName = (colors: ProductColor[], name?: string | null) => {
   if (!name) return undefined;
   if (name === OTHER_COLOR_NAME) return OTHER_COLOR_ID;
   if (name === UNKNOWN_COLOR_NAME) return UNKNOWN_COLOR_ID;
   return colors.find((color) => color.name === name)?.id;
};
